import { Separator as UiSeparator } from '@/components/ui/separator'
import { cn } from '@/lib/utils'

import { separatorVariants } from '../../configs/separator.config'

import type { ComponentProps } from 'react'

export function Separator({ className, orientation, ...props }: ComponentProps<typeof UiSeparator>) {
  return (
    <UiSeparator
      orientation={orientation}
      className={cn(separatorVariants({ orientation }), className)}
      {...props}
    />
  )
}
